module.exports = "<div class=\"header\">\n    <img src=\"../assets/images/logo/PSA-Fin-copy.png\" class=\"img-responsive\" />\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/header/header.component.html
// module id = ./src/app/common/header/header.component.html
// module chunks = main